<div
  class="photo"
  cdkDragHandle
  [style.width.px]="width"
  [style.height.px]="height"
  [style.backgroundImage]="'url(' + video + ')'"
>
  <div class="flex photo-content jcsb">
    <rx-row class="flex-nosize" [ngClass]="hasCheckbox ? 'jcsb' : 'jcfe'">
      <mat-checkbox
        [checked]="checked"
        (change)="checkedChanged($event)"
        (click)="clickCheckbox($event)"
        *ngIf="hasCheckbox"
        [disabled]="disableCheckbox"
      >
      </mat-checkbox>

      <rx-icon
        name="icon-drag"
        class="light"
        *ngIf="showDragHandle"
        (mouseenter)="onEnableDrag(true)"
        (mouseleave)="onEnableDrag(false)"
        cdkDragHandle
      >
      </rx-icon>

      <div class="action-controls flex flex-row flex-nosize" *ngIf="showMenuHandle">
        <rx-icon
          *ngIf="showMenuHandle"
          name="icon-shadow-menu"
          class="rel z1 cp"
          [class.disabled]="disableMenu"
          (click)="onMenuClicked($event)"
          [matMenuTriggerFor]="actionMenu"
          [matMenuTriggerData]="actionMenuContext"
        ></rx-icon>
      </div>
    </rx-row>

    <div class="flex flex-row jcc aic play-control">
      <mat-icon (click)="onShowPreview()"> play_circle_outline </mat-icon>
    </div>

    <div class="description">
      {{ description }}
    </div>
  </div>
</div>
